import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { CreateClarraDocsform, GraphMicrosoftBaseURL, Attachments, value } from "../../config/config";

interface AttachmentMetadata {
  Id: number;
  DownloadURL: string;
  Name: string;
}

const getAttachmentMetadata = async (): Promise<AttachmentMetadata[]> => {
  try {
    if (!window.Office?.context?.mailbox?.item) {
      return [];
    }

    const item = Office.context.mailbox.item;

    if (!item.attachments?.length) {
      return [];
    }

    const restItemId = Office.context.mailbox.convertToRestId(
      item.itemId,
      Office.MailboxEnums.RestVersion.v2_0
    );

    return item.attachments.map((att, index) => ({
      Id: index,
      DownloadURL : `${GraphMicrosoftBaseURL}${restItemId}${Attachments}${att.id}${value}`,
      Name: att.name
    }));

  } catch (error) {
    console.error("Error in getAttachmentMetadata:", error);
    return [];
  }
};

export const SaveClarraDocs = createAsyncThunk(
  'clarraDocs/SaveClarraDocsLog',
   async (FormData:any) => {
    FormData.data ="";
    let index =1;

    const fullAttachmentList = await getAttachmentMetadata();
    
    if (fullAttachmentList && fullAttachmentList.length > 0) {
        // Filter the list based on what is currently in UploadFileAttachments
        if (FormData.UploadFileAttachments) {
            const selectedFilenames = FormData.UploadFileAttachments.map(
                (file: any) => file.filename
            );
            
            const filteredList = fullAttachmentList.filter((zapAtt) =>
                selectedFilenames.includes(zapAtt.Name)
            );

            // Add the filtered metadata array to FormData (Stringify for multipart)
            FormData.ZapierDownloadURL = JSON.stringify(filteredList);
            console.log("ClarraDocs: Added ZapierDownloadURL:", filteredList);
        }
    }

    FormData.UploadFileAttachments.forEach(element => {
   
      if(element.filename !=""){
        ;
        const file =  new File([element.blobfile], element.filename);
       
        switch(index){
          case 1 :  FormData.UploadSingleAttachments1 = file;break;
          case 2 :  FormData.UploadSingleAttachments2 = file; break;
          case 3 :  FormData.UploadSingleAttachments3 = file; break;
          case 4 :  FormData.UploadSingleAttachments4 = file; break;
          case 5 :  FormData.UploadSingleAttachments5 = file; break;
          case 6 :  FormData.UploadSingleAttachments6 = file; break;
      }
      index = index +1;
    } 
    FormData.UploadFileAttachments = null;
    });
 
   const response  = await apiClient.post(CreateClarraDocsform , FormData, {
    headers: {
      //'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      Accept: '*/*',
      'mode': 'outlook'
    },
  });

  return response;

  }
);

const clarraDocsSlice = createSlice({
  name: 'clarraDocs',
  initialState: {
    clarraDocs : null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SaveClarraDocs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SaveClarraDocs.fulfilled, (state, action) => {
        state.loading = false;
        state.clarraDocs = action.payload;
      })
      .addCase(SaveClarraDocs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  }
});

export default clarraDocsSlice.reducer;
